import React, { useState } from 'react';
import ProductTable from "../../../components/tables/ProductTable";
import InvoiceTransactionTable from "../../../components/tables/AdminInvoiceTransactionTable";
import {Button} from "../../../components/buttons";
import {CSVLink} from "react-csv";
import axios from "axios";
import {API} from "../../../config";
import numeral from "numeral";
import { FormModalButton } from "../../../components/organisms"
import Invoice from "../../../components/templates/pdfs/InvoiceOld";
import { PDFDownloadLink} from '@react-pdf/renderer'
import {CopyToClipboard} from "react-copy-to-clipboard";
import moment from 'moment';
import { createInvoice } from '../../../store/action/invoice';
import { 
    updateUserSubscriptionByAdmin,
    removeUserSubscriptionByAdmin
} from "../../../store/action/user"
import {
    getOrderByAdmin
} from "../../../store/action/order"
import { normalizeCourierServices } from "../../../services/helpers/courier";

const AdminUserPaymentInfo = (props) => {
    const [ download, setDownload ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const [ invoiceReady, setInvoiceReady ] = useState(false);
    const [ invoiceLoading, setInvoiceLoading ] = useState(false);
    const [ orderLoading, setOrderLoading ] = useState(false);
    const [ paymentLoading, setPaymentLoading] = useState(false);
    const [ downloadLoading, setDownloadLoading ] = useState(false);
    const [ fulfillmentExtra, setFulfillmentExtra ] = useState({
        type:'Fulfillment',
        service:'',
        details:'',
        quantity:0,
        price:0,
    })
    const [ invoice, setInvoice ] = useState({
        invoiceNo: ``,
        name: props.user.name,
        company: props.user.organizationName,
        email: props.user.email,
        phone: props.user.phone,
        address: props.user.address,
        period: "",
        issueDate: moment().format('DD MMMM YYYY'),
        dueDate: moment().add(14,'days').format('DD MMMM YYYY'),
        items: [
          {
            type:'',
            service:'',
            details:'',
            quantity:0,
            price:0,
          }
        ]
    });
    const [ values, setValues ] = useState({
        start: '',
        end: '',
        limit: '',
        amount:'',
        addOrderId:''
    });
    const [ files, setFiles] = useState({
        shipmentsSummary:[],
        shipmentsDetails:[],
        pricingRequestDetails:[],
        paymentSummary:[],
        storageDetails:[]
    });

    const contentEmail  = `Dear ${invoice.company},

Terlampir data transaksi untuk periode November 2020

Mohon melakukan konfirmasi transaksi dan klaim barang (apabila ada) 5 hari setelah invoice ini dikirim via email. Apabila tidak ada konfirmasi sampai tanggal yang disetujui, kami menganggap bahwa:
Tidak ada perbedaan transaksi
Tidak ada barang yang hilang
Perihal pembayaran tagihan dapat dilakukan paling lambat 14 Hari setelah invoice dikirim via email dan lakukan pembayaran melalui rekening di bawah ini

Bank : PT Bank Centra Asia Tbk (BCA)
Nomor Rekening : 5425210618
Nama Rekening : PT Noompang Kreasi Nusantara

Apabila telah melakukan pembayaran via bank transfer, mohon untuk mengirimkan bukti pembayarannya dengan membalas email ini.

Thank you and have a great day!
`;

    const submitAdjustment = async (type) => {
        setPaymentLoading(true)
        try {
            const res = await axios.post(`${API}/v1/admin/transactions`, {
                amount: values.amount,
                user_id: props.user.id,
                type: type
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${props.token}`
                }
            });
            if(res.data.success) {
                alert('Berhasil adjust wallet')
                window.location.reload()
            } else {
                alert('Gagal adjust wallet')
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
        }
        setPaymentLoading(false)
    };


    const downloadPayment = async () => {
        setDownloadLoading(true)
        try {
            const res = await axios.post(`${API}/v1/admin/financials/users/${props.user.id}`, {
                start: values.start,
                end: values.end,
                limit: values.limit
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${props.token}`
                }
            });
            if(res.data.success) {
                const files = res.data;
                setInvoice({
                    ...invoice, 
                    period:moment(values.start,"YYYY-MM-DD").format('MMMM YYYY'),
                })
                setDownload(true);
                const shipmentsForSummary = files.shipments_summary.reduce((r,i) => {
                    r.push({
                        type:'Shipment',
                        service:i.courier,
                        details:i.service,
                        quantity: i.quantity,
                        price: i.price
                    });
                    return r
                },[]);
                const totalQtyShipments = files.shipments_summary.reduce((r,i) => {
                    return r + i.quantity
                },0);
                const totalPriceShipments = files.shipments_summary.reduce((r,i) => {
                    return r + i.price
                },0);

                const subscriptionPrice = props.user.subscriptions.reduce((r, i) => {
                    r.push({
                        type:'Subscription',
                        service:i.name,
                        details:i.type,
                        quantity: i.cycle,
                        price: i.price
                    }) 
                    return r
                },[])
                const totalSubsPrice = props.user.subscriptions.reduce((r,i) => {
                    return r + i.price
                },0);

                const grandTotal = parseInt(files.storage_price)+
                    parseInt(files.pick_and_pack_price)+
                    parseInt(totalPriceShipments)+
                    parseInt(totalSubsPrice)

                let shipmentView,fulfillmentStorageView,fulfillmentPickNPackView,fulfillmentTotalView, subsView;
                if (totalPriceShipments === 0) {
                    shipmentView = []
                } else {
                    shipmentView = [
                        ...shipmentsForSummary,
                        {
                            type:'Shipment',
                            service:"Total",
                            details:'',
                            quantity: totalQtyShipments,
                            price: totalPriceShipments
                        }
                    ]
                }

                if (files.storage_price === 0) {
                    fulfillmentStorageView = []
                } else {
                    fulfillmentStorageView = [{
                        type:'Fulfillment',
                        service:"Storage",
                        details:'',
                        quantity: files.storage_quantity,
                        price: files.storage_price
                    }]
                }

                if (files.pick_and_pack_price === 0) {
                    fulfillmentPickNPackView = []
                } else {
                    fulfillmentPickNPackView = [{
                        type:'Fulfillment',
                        service:"Pick and Pack",
                        details:'',
                        quantity: files.pick_and_pack_quantity,
                        price: files.pick_and_pack_price
                    }]
                }

                if (files.storage_price+files.pick_and_pack_price === 0) {
                    fulfillmentTotalView = []
                } else {
                    fulfillmentTotalView = [{
                        type:'Fulfillment',
                        service:"Total",
                        details:'',
                        quantity: '',
                        price: files.storage_price+files.pick_and_pack_price
                    }]
                }
                if (totalSubsPrice === 0) {
                    subsView = []
                } else {
                    subsView = subscriptionPrice
                }
                const newPaymentSummary = [
                    ...shipmentView,
                    ...fulfillmentStorageView,
                    ...fulfillmentPickNPackView,
                    ...fulfillmentTotalView,
                    ...subsView,
                    {
                        type:'Grand Total',
                        service:"",
                        details:'',
                        quantity: '',
                        price: grandTotal
                    },
                ]
                setFiles({
                    shipmentsSummary:files.shipments_summary,
                    shipmentsDetails:files.shipments_details,
                    pricingRequestDetails: files.pricing_request_details,
                    storageDetails: files.storage_details,
                    paymentSummary:newPaymentSummary
                })
                setInvoice({
                    ...invoice,
                    items:newPaymentSummary
                })
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            console.log (e);
            return alert(e.message)
        }
        setDownloadLoading(false)
    };
    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value });
        if (name === 'start') {
            setInvoice({ ...invoice, period: event.target.value });
        }
    };

    const handleFulfillmentChange = name => event => {
        setFulfillmentExtra({ ...fulfillmentExtra, [name]: event.target.value });
    };
    const onInvoiceNoChange = name => event => {
        setInvoice({ ...invoice, [name]: event.target.value });
    };
    if (props.loading) {
        return <p>Loading...</p>
    }

    const convertNewSummary = (shipmentsDetails,paymentSummary) => {
        const filteredPaymentSummary = paymentSummary.filter(i => i.type !== 'Shipment' && i.type !== 'Grand Total')
        const filteredTotalPrice = filteredPaymentSummary.reduce((r,i) => {
            if (i.service !== 'Total') {
                return r + i.price
            } else {
                return r
            }  
        },0);
        let helper = {};
        let groupByServiceAndCompany = shipmentsDetails.reduce(function(r, o) {
                let key = o.courier_company + '-' + o.courier_service;
                if(!helper[key]) {
                    helper[key] = Object.assign({}, o); // create a copy of o
                    r.push(helper[key]);
                } else {
                    helper[key].price += o.price;
                    helper[key].quantity += o.quantity;
                }
                return r;
        }, []);

        const shipmentsSummary = groupByServiceAndCompany.reduce((r,i) => {
            if (i.price) {
                r.push({
                    courier: i.courier_company,
                    service: i.courier_service,
                    quantity: i.quantity,
                    price: i.price
                });
            }
            return r
        },[]);
        
        const shipmentsForSummary = shipmentsSummary.reduce((r,i) => {
            r.push({
                type:'Shipment',
                service:i.courier,
                details:i.service,
                quantity: i.quantity,
                price: i.price
            });
            return r
        },[]);
        const totalQtyShipments = shipmentsSummary.reduce((r,i) => {
            return r + i.quantity
        },0);
        const totalPriceShipments = shipmentsSummary.reduce((r,i) => {
            return r + i.price
        },0);

        let shipmentView;
        if (totalPriceShipments === 0) {
            shipmentView = []
        } else {
            shipmentView = [
                ...shipmentsForSummary,
                {
                    type:'Shipment',
                    service:"Total",
                    details:'',
                    quantity: totalQtyShipments,
                    price: totalPriceShipments
                }
            ]
        }

        const grandTotal = parseInt(filteredTotalPrice)+ parseInt(totalPriceShipments)

        const newPaymentSummary = [
            ...shipmentView,
            ...filteredPaymentSummary,
            {
                type:'Grand Total',
                service:"",
                details:'',
                quantity: '',
                price: grandTotal
            }
        ]
        return newPaymentSummary
    }

    const addOrderIdFunc = async (orderId) => {
        const resp = await getOrderByAdmin(props.token,orderId,'invoices')
        let { 
            shipmentsDetails,
            paymentSummary
        } = files;

        if (!resp.success) {
            alert("tidak ada order id")
            setOrderLoading(false)
            return
        }

        for (let i = 0; i < resp.items.length; i++) {
            let itemNameI;
            if (resp.items[i].name && resp.items[i].description) {
                itemNameI = resp.items[i].name + ' - ' + resp.items[i].description
            } else if (resp.items[i].name && !resp.items[i].description) {
                itemNameI = resp.items[i].name
            } else if (!resp.items[i].name && resp.items[i].description) {
                itemNameI =  resp.items[i].description
            }

            if (i === 0) {
                shipmentsDetails.push({
                    order_id: resp.id,
                    waybill_id: resp.courier.waybill_id,
                    shipper_name: resp.shipper.name,
                    shipper_organization: resp.shipper.organization,
                    origin_name:resp.origin.contact_name,
                    origin_address: resp.origin.address,
                    destination_name: resp.destination.contact_name,
                    destination_address: resp.destination.address,
                    destination_note: resp.destination.note,
                    note:resp.note,
                    item_name: itemNameI,
                    item_price: resp.items[i].value,
                    item_dimension: `${resp.items[i].length || 10}x${resp.items[i].width || 10}x${resp.items[i].height|| 10}`,
                    item_weight: resp.items[i].weight || 1000,
                    courier_company: resp.courier.company,
                    courier_service: normalizeCourierServices(resp.courier.company,resp.courier.type).typeCamelCaseFormat,
                    delivery_time: moment(resp.delivery.datetime).format("YYYY-MM-DD HH:MM:ss") ,
                    quantity: resp.items.length || 1,
                    basic_price: resp.basic_price,
                    discount_percentage: resp.discount_percentage,
                    discount_price: resp.discount_price,
                    price: resp.price
                })
            } else {
                shipmentsDetails.push({
                    order_id:"",
                    waybill_id:"",
                    shipper_name:"",
                    shipper_organization:"",
                    origin_name:"",
                    origin_address:"",
                    destination_name:"",
                    destination_address:"",
                    destination_note:"",
                    note:"",
                    item_name: itemNameI,
                    item_price: resp.items[i].value,
                    item_dimension: `${resp.items[i].length || 10}x${resp.items[i].width || 10}x${resp.items[i].height|| 10}`,
                    item_weight: resp.items[i].weight || 1000,
                    courier_company:"",
                    courier_service:"",
                    delivery_time:"",
                    quantity:"",
                    basic_price:"",
                    discount_percentage:"",
                    discount_price:"",
                    price:"",
                })
            }
        }
       
        const newPaymentSummary = convertNewSummary(shipmentsDetails,paymentSummary)
        
        setFiles({
            ...files,
            shipmentsDetails,
            paymentSummary:newPaymentSummary
        })
        setInvoice({
            ...invoice,
            items:newPaymentSummary
        })
    }


    const addOrderIdToTransaction = async () => {
        setOrderLoading(true)
        if (values.addOrderId.split(/\n/).length > 1) {
            const orderIds = values.addOrderId.split(/\n/);
            for (let i = 0; i < orderIds.length;i++) {
                if (orderIds[i] === "") {
                    alert("tidak boleh ada line baru. Hapuskan enter yang terakhir. ")
                    setOrderLoading(false)
                    return
                }
                await addOrderIdFunc(orderIds[i])
            }
        } else {
            await addOrderIdFunc(values.addOrderId)
        }
        setOrderLoading(false)
    }

    const removeOrderIdFromTransaction = async () => {
        let { 
            shipmentsDetails,
            paymentSummary
        } = files;
        const orderIds = values.addOrderId.split(/\n/);

        const filteredShipmentsDetails = shipmentsDetails.filter(i => !orderIds.includes(i.order_id))
        const newPaymentSummary = convertNewSummary(filteredShipmentsDetails,paymentSummary)
        
        setFiles({
            ...files,
            shipmentsDetails:filteredShipmentsDetails,
            paymentSummary:newPaymentSummary
        })
        setInvoice({
            ...invoice,
            items:newPaymentSummary
        })
    }

    const onSubmitSubs = async (value) => {
        const data = JSON.parse(value);
        const resp = await updateUserSubscriptionByAdmin(props.token,props.user.id,data)
        if (!resp.success) {
            alert('gagal update subscription')
            return 
        }

        alert('berhasil tambah subscription')
        window.location.reload()
    }

    const onRemoveSubs = async (idx) => {
        const resp = await removeUserSubscriptionByAdmin(props.token,props.user.id,{index:idx})
        if (!resp.success) {
            alert('gagal delete subscription')
            return 
        }

        alert('berhasil delete subscription')
        window.location.reload()
    }

    const onSubmitDiscount = (dv) => {
        let { paymentSummary } = files;
        const discountValue = 1 - (dv/100)
        const filteredPaymentSummary = paymentSummary.filter(i => i.type !== 'Fulfillment' && i.type !== 'Grand Total')
        const filteredFulfillmentStorage = paymentSummary.filter(i => i.service === 'Storage')
        const fulfillmentStorage = filteredFulfillmentStorage.length > 0 ? filteredFulfillmentStorage[0] : {price:0}
        const filteredFulfillmentPickPack = paymentSummary.filter(i => i.service === 'Pick and Pack')
        const fulfillmentPickPack = filteredFulfillmentPickPack.length > 0 ? filteredFulfillmentPickPack[0] : {price:0}

        const filteredTotalPrice = filteredPaymentSummary.reduce((r,i) => {
            if (i.service !== 'Total') {
                return r + i.price
            } else {
                return r
            }  
        },0);

        let fulfillmentStorageView, fulfillmentPickNPackView, fulfillmentTotalView
        if (fulfillmentStorage.price === 0) {
            fulfillmentStorageView = []
        } else {
            fulfillmentStorageView = [{
                type:'Fulfillment',
                service:"Storage",
                details:'',
                quantity: fulfillmentStorage.quantity,
                price: fulfillmentStorage.price*discountValue
            }]
        }

        if (fulfillmentPickPack.price === 0) {
            fulfillmentPickNPackView = []
        } else {
            fulfillmentPickNPackView = [{
                type:'Fulfillment',
                service:"Pick and Pack",
                details:'',
                quantity: fulfillmentPickPack.quantity,
                price: fulfillmentPickPack.price
            }]
        }

        if (fulfillmentStorage.price+fulfillmentPickPack.price === 0) {
            fulfillmentTotalView = []
        } else {
            fulfillmentTotalView = [{
                type:'Fulfillment',
                service:"Total",
                details:'',
                quantity: '',
                price: (fulfillmentStorage.price*discountValue)+fulfillmentPickPack.price
            }]
        }

        const grandTotal = parseInt(filteredTotalPrice)+ 
            parseInt(fulfillmentTotalView[0].price)

        const newPaymentSummary = [
            ...filteredPaymentSummary,
            ...fulfillmentStorageView,
            ...fulfillmentPickNPackView,
            ...fulfillmentTotalView,
            {
                type:'Grand Total',
                service:"",
                details:'',
                quantity: '',
                price: grandTotal
            }
        ]

        setFiles({
            ...files,
            paymentSummary:newPaymentSummary
        })
        setInvoice({
            ...invoice,
            items:newPaymentSummary
        })
    }

    const onSubmitSubsDiscount = (value,sub) => {
        let { paymentSummary } = files;
        const filteredSelectedSubs = paymentSummary.filter(i => i.details === sub.details && i.service === sub.service)
        const filteredSubs = paymentSummary.filter(i => i.service !== sub.service && i.type !== "Grand Total" )
        
        const filteredTotalPrice = filteredSubs.reduce((r,i) => {
            if (i.service === 'Total') {
                return r
            } else {
                return r = r + i.price
            }
        },0)

        const newPrice = filteredSelectedSubs[0].price*(1-(value/100));
        const grandTotal = parseInt(filteredTotalPrice)+ 
        parseInt(newPrice)

        const newPaymentSummary = [
            ...filteredSubs,
            {
                type:'Subscription',
                service:sub.service,
                details:sub.details,
                quantity:sub.quantity,
                price: newPrice
            },
            {
                type:'Grand Total',
                service:"",
                details:'',
                quantity: '',
                price: grandTotal
            }
        ]


        setFiles({
            ...files,
            paymentSummary:newPaymentSummary
        })
        setInvoice({
            ...invoice,
            items:newPaymentSummary
        })
    }

    const onCreateInvoice = async () => {
        setInvoiceLoading(true)
        const inv = invoice;
        const filterItemGrandTotal = inv.items.filter(i => i.type !== 'Grand Total')
        const filterItemTotal = filterItemGrandTotal.filter(i => i.service !== 'Total')
        const data = {
            reference_id: inv.invoiceNo,
            bill_to_user_id: props.user.id,
            bill_to_name: inv.name,
            bill_to_company: inv.company,
            bill_to_email: inv.email,
            bill_to_phone: inv.phone,
            bill_to_address: inv.address,
            period: moment(values.start,"YYYY-MM-DD").format('MMMM YYYY'),
            issued_at: inv.issueDate,
            due_at: inv.dueDate,
            items: filterItemTotal
        }
        const create = await createInvoice(props.token,data)
        if (create.success) {
            alert("Berhasil di save")
            setInvoiceLoading(false)
        }
        setInvoiceLoading(false)
    }

    const addFulfillmentExtra = () => {
        let { paymentSummary } = files;
        const filteredShipment = paymentSummary.filter(i => i.type === 'Shipment')
        const shipmentTotalPrice = filteredShipment.filter(i => i.service === 'Total')[0].price;
        const filteredSubs = paymentSummary.filter(i => i.type === 'Subscription')
        const subsTotalPrice = filteredSubs.reduce((r,i) => {
            return r = r + i.price
        },0)
        const filteredFulfillment = paymentSummary.filter(i => i.type === 'Fulfillment')
        const filteredFulfillmentTotal = filteredFulfillment.filter(i => i.service === 'Total')
        const filteredFulfillmentWithoutTotal = filteredFulfillment.filter(i => i.service !== 'Total')
        filteredFulfillmentWithoutTotal.push(fulfillmentExtra)
        const fulfillmentTotalPrice = filteredFulfillmentWithoutTotal.reduce((r,i) => {
            return r = r + parseInt(i.price)
        },0)

        const grandTotal = parseInt(shipmentTotalPrice)+ 
            parseInt(subsTotalPrice) +
            parseInt(fulfillmentTotalPrice)

        const newPaymentSummary = [
            ...filteredShipment,
            ...filteredFulfillmentWithoutTotal,
            {
                type:'Fulfillment',
                service:"Total",
                details:'',
                quantity: '',
                price: fulfillmentTotalPrice
            },
            ...filteredSubs,
            {
                type:'Grand Total',
                service:"",
                details:'',
                quantity: '',
                price: grandTotal
            }
        ]

        setFiles({
            ...files,
            paymentSummary:newPaymentSummary
        })
        setInvoice({
            ...invoice,
            items:newPaymentSummary
        })
    }

    const downloadView = () => {
        if (download) {
            return (
                <div className="px-4">
                    <h6>Download File </h6>
                    <div className="row">
                        <div className="col-2">
                            <CSVLink
                                className="btn btn-sm btn-outline-primary btn-block"
                                separator={"|"}
                                filename={`[${props.user.organizationName}] Biteship Invoice Summary - ${invoice.invoiceNo}.csv`}
                                data={files.paymentSummary}>
                                <span className="btn-inner--text ml-2">All Summary</span>
                            </CSVLink>
                        </div>
                        <div className="col-2">
                            <CSVLink
                                className="btn btn-sm btn-outline-primary btn-block"
                                separator={"|"}
                                filename={`[${props.user.organizationName}] Biteship Shipment Details - ${invoice.invoiceNo}.csv`}
                                data={files.shipmentsDetails}>
                                <span className="btn-inner--text ml-2">Shipment Details</span>
                            </CSVLink>
                        </div>
                        <div className="col-2">
                            <CSVLink
                                className="btn btn-sm btn-outline-primary btn-block"
                                separator={"|"}
                                filename={`[${props.user.organizationName}] Biteship Storage Details - ${invoice.invoiceNo}.csv`}
                                data={files.storageDetails}>
                                <span className="btn-inner--text ml-2">Storage Details</span>
                            </CSVLink>
                        </div>
                        <div className="col-2 input-group-sm">
                            <input
                                type="text"
                                onChange={onInvoiceNoChange('invoiceNo')}
                                placeholder="Nomor Invoice"
                                className="form-control"
                                values={invoice.invoiceNo}
                            />
                        </div>
                        <div className="col-2">
                            {
                                invoiceReady ? 
                                    <PDFDownloadLink className="btn btn-sm btn-primary btn-block" document={<Invoice invoice={invoice}/>} fileName={`[${invoice.company}] Biteship Invoice - #${invoice.invoiceNo}.pdf`}>
                                        {({ blob, url, loading, error }) => (loading ? 'Memuat...' : 'Download Invoice')}
                                    </PDFDownloadLink>
                                    :
                                    <Button className="btn btn-sm btn-outline-primary btn-block" onClick={() => invoice.invoiceNo ?  setInvoiceReady(true) : alert("Isi nomor invoice terlebih dahulu")}>
                                        Siapkan Invoice
                                    </Button>
                            }
                        </div>
                        <div className="col-2">
                            <Button disable={invoice.invoiceNo ? false : true} className={`${invoice.invoiceNo ?  "btn-primary" : "btn-secondary"} btn btn-sm btn-block`} onClick={() => onCreateInvoice()}>
                                {invoiceLoading ? "Saving... ":"Save Invoice"}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }
        return null
    };

    const detailView = () => {
        if (download) {
            return (
                <div className="px-4">
                    <h6>Summary Transaksi </h6>
                    {
                        files.paymentSummary.map((i,idx) => {
                            return (
                                <div key={idx} className="row border rounded py-2 mb-1">
                                    <div className="col-2">
                                        {i.type}
                                    </div>
                                    <div className="col-2">
                                        {i.service}
                                    </div>
                                    <div className="col-2">
                                        {i.details}
                                    </div>
                                    <div className="col-2">
                                        {i.quantity}
                                    </div>
                                    <div className="col-2">
                                    Rp. {numeral(i.price).format("0,0")}
                                    </div>
                                    <div className="col-2">
                                        {
                                            i.type === 'Fulfillment' && i.service === 'Storage' ? 
                                            <FormModalButton 
                                                className="btn btn-sm btn-primary"
                                                buttonText="Tambah Diskon"
                                                onButtonClick={value => onSubmitDiscount(value)}
                                            /> : null     
                                        }
                                        {
                                            i.type === 'Subscription' ? 
                                            <FormModalButton 
                                                className="btn btn-sm btn-primary"
                                                buttonText="Tambah Diskon"
                                                onButtonClick={value => onSubmitSubsDiscount(value,i)}
                                            /> : null     
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            )
        }
    }
    const emailTools = () => {
        if (download) {
            return (
                <div className="px-4">
                    <h6>Tools for Email</h6>
                    <CopyToClipboard
                        text={`${invoice.email}`}
                        onCopy={() => alert('Sudah dicopy')}
                    >
                        <button
                                className="badge badge-info border border-info pointer py-2"
                        >
                            Copy Email
                        </button>
                    </CopyToClipboard>
                    <CopyToClipboard
                        text={`[${invoice.company}] Biteship Invoice - ${moment(values.start,"YYYY-MM-DD").format('MMMM YYYY')} - ${invoice.invoiceNo}`}
                        onCopy={() => alert('Sudah dicopy')}
                    >
                        <button
                                className="ml-2 badge badge-info border border-info pointer py-2"
                        >
                            Copy Judul
                        </button>
                    </CopyToClipboard>
                    <CopyToClipboard
                        text={contentEmail}
                        onCopy={() => alert('Sudah dicopy')}
                    >
                        <button
                                className="ml-2 badge badge-info border border-info pointer py-2"
                        >
                            Copy Content
                        </button>
                    </CopyToClipboard>
                </div>
            )
        }
    }
    const editShipmentView = () => {
        if (download) {
            return (
                <div className="px-4">
                    <h6>Edit Transaksi Shipment</h6>
                    <div className="col-10 form-inline">
                        <div className="form-group mr-2">
                            <textarea
                                type="text"
                                onChange={handleChange('addOrderId')}
                                placeholder="Order ID"
                                className="form-control"
                                values={values.addOrderId}
                            />
                        </div>
                        <Button
                            onClick={() => addOrderIdToTransaction()}
                            loading={orderLoading}
                            className={`${orderLoading ? "btn-secondary" : "btn-primary"} btn mr-2`}
                        >
                            {orderLoading ? "Submitting..." : "Tambah"}
                        </Button>
                        <Button
                            onClick={() => removeOrderIdFromTransaction()}
                            loading={orderLoading}
                            className={`${orderLoading ? "btn-secondary" : "btn-danger"} btn mr-2`}
                        >
                            {orderLoading ? "Submitting..." : "Kurang"}
                        </Button>
                    </div>
                </div>
            )
        }
    }

    const editFulfillmentView = () => {
        if (download) {
            return (
                <div className="px-4">
                <h6>Edit Transaksi Fulfillment</h6>
                <div className="col-12 form-inline">
                    <div className="form-group mr-2">
                        <input
                            type="text"
                            onChange={handleFulfillmentChange('service')}
                            placeholder="Layanan"
                            className="form-control"
                            values={fulfillmentExtra.service}
                        />
                    </div>
                    <div className="form-group mr-2">
                        <input
                            type="text"
                            onChange={handleFulfillmentChange('details')}
                            placeholder="Detail "
                            className="form-control"
                            values={fulfillmentExtra.details}
                        />
                    </div>
                    <div className="form-group mr-2">
                        <input
                            type="number"
                            onChange={handleFulfillmentChange('quantity')}
                            placeholder="Jumlah"
                            className="form-control"
                            values={fulfillmentExtra.qauntity}
                        />
                    </div>
                    <div className="form-group mr-2">
                        <input
                            type="number"
                            onChange={handleFulfillmentChange('price')}
                            placeholder="Harga"
                            className="form-control"
                            values={fulfillmentExtra.price}
                        />
                    </div>
                
                    <Button
                        onClick={() => addFulfillmentExtra()}
                        loading={orderLoading}
                        className={`${orderLoading ? "btn-secondary" : "btn-primary"} btn mr-2`}
                    >
                        {orderLoading ? "Submitting..." : "Tambah"}
                    </Button>
                </div>
            </div>
            )
        }
    }

    const transactionView = () => {
        if (download) {
            return (
                <div>
                    <div className="px-4">
                        <h6>Detail Transaksi </h6>
                    </div>
                    <InvoiceTransactionTable data={files.shipmentsDetails}/>
                </div>
            )
        } 
    }

    return (
        <div>
            <div className="row px-4 pt-4 pb-2">
                <div className="col-6">
                    <h5>Saldo: Rp. {numeral(props.user.balance).format("0,0")}   </h5>
                </div>
                <div className="col-6 form-inline">
                    <div className="form-group mr-2">
                        <input
                            type="text"
                            onChange={handleChange('amount')}
                            placeholder="Nominal"
                            className="form-control"
                            values={props.values.status}
                        />
                    </div>
                    <Button
                        onClick={() => submitAdjustment('paymentRefund')}
                        loading={props.loading}
                        className="btn btn-primary mr-2"
                    >
                        {props.loading ? "Submitting..." : "Tambah"}
                    </Button>
                    <Button
                        onClick={() => submitAdjustment('payment')}
                        loading={props.loading}
                        className="btn btn-danger"
                    >
                        {props.loading ? "Submitting..." : "Kurang"}
                    </Button>
                    {
                        paymentLoading ? <p>Sedang adjusting</p> : null
                    }
                </div>
            </div>
            <hr/>
            <div className="row px-4 pt-2 pb-2">
                <div className="col-6">
                    <h5>Pembayaran </h5>
                    <p>Status Pembayaran: <b>{props.user.paymentStatus} </b></p>
                    <p>Due Date Pembayaran: <b>{props.user.paymentDueDate} </b></p>
                    <br/>
                </div>
                <div className="col-6">
                    <h5>Update Info Pembayaran </h5>
                    <div className="form-group">
                        <input
                            type="text"
                            onChange={props.handleChange('status')}
                            placeholder="Status Pembayaran"
                            className="form-control"
                            values={props.values.status}
                        />
                    </div>

                    <div className="form-group">
                        <input
                            type="text"
                            onChange={props.handleChange('dueDate')}
                            placeholder="Due Date (YYYY-MM-DD)"
                            className="form-control"
                            values={props.values.dueDate}
                        />
                    </div>
                    <Button
                        onClick={props.onSubmit}
                        loading={props.loading}
                        className="btn btn-primary btn-block"
                    >
                        {props.loading ? "Submitting..." : "Submit"}
                    </Button>
                </div>
            </div>
            <hr/>
            <div className="px-4 pt-2 pb-4 mb-2">
                <div className="mb-3">
                    <div className="">
                        <h5>Courier Discounts </h5>
                    </div>
                    <div className="col-12">
                        {
                            props.user.courierDiscounts.length === 0 ? 
                            <div>
                                <p>Tidak ada diskon</p>
                            </div>
                            :
                            props.user.courierDiscounts.map((i, idx) => (
                                <div key={idx} className="px-3">
                                    <div className="row bg-lighter border rounded py-2 mb-2">
                                        <div className="col-sm-3">
                                            <b>{i.courierCode}</b>
                                        </div>
                                        <div className="col-sm-3">
                                            <b>{i.serviceCode}</b>
                                        </div>
                                        <div className="col-sm-2">
                                            <b>{i.discountPercentage}%</b>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                 
                </div>
            </div>
            <hr/>
            <div className="px-4 pt-2 pb-4 mb-2">
                <div className="d-flex justify-content-between mb-3">
                    <div className="">
                        <h5>Subscriptions </h5>
                    </div>
                    <div className="">
                        <FormModalButton 
                            className="btn btn-primary"
                            type="options"
                            buttonText="Tambah Subcription"
                            options={subscriptionOption}
                            onButtonClick={value => onSubmitSubs(value)}
                        />
                    </div>
                </div>
                
                <div className="col-12">
                        {
                            props.user.subscriptions.map((i, idx) => (
                                <div key={idx} className="px-3">
                                    <div className="row bg-lighter border rounded py-2 mb-2">
                                        <div className="col-sm-3">
                                            <b>{i.name}</b>
                                        </div>
                                        <div className="col-sm-2">
                                            <b>{i.type}</b>
                                        </div>
                                        <div className="col-sm-2">
                                            {i.cycle}
                                        </div>
                                        <div className="col-sm-4">
                                            Rp. {numeral(i.price).format("0,0")}
                                        </div>
                                        <div className="col-sm-1">
                                            <a onClick={() => onRemoveSubs(idx)}
                                                className="action-item mr-2"
                                                data-toggle="tooltip"
                                                title="Remove">
                                                    <i className="fas fa-times"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                </div>
            </div>
            <hr/>
       
            <div className="px-4 pt-2 pb-4 mb-2">
                <div className="">
                    <h5>Generate Invoice </h5>
                </div>
                <div className="row">
                    <div className="col-3">
                        <input
                            type="text"
                            onChange={handleChange('start')}
                            placeholder="Start Date (YYYY-MM-DD)"
                            className="form-control"
                            values={values.start}
                        />
                    </div>
                    <div className="col-3">
                        <input
                            type="text"
                            onChange={handleChange('end')}
                            placeholder="End Date (YYYY-MM-DD)"
                            className="form-control"
                            values={values.end}
                        />
                    </div>
                    <div className="col-3">
                        <input
                            type="text"
                            onChange={handleChange('limit')}
                            placeholder="First Month Date (YYYY-MM-DD)"
                            className="form-control"
                            values={values.limit}
                        />
                    </div>
                    <div className="col-3">
                        <Button
                            onClick={downloadPayment}
                            loading={loading}
                            className="btn btn-primary btn-block"
                        >
                            {downloadLoading ? "Submitting..." : "Submit"}
                        </Button>
                    </div>
                </div>
            </div>
            { downloadView() }
            <br/>
            { detailView() }
            <br/>
            { emailTools() }
            <br/>
            { editShipmentView() }
            <br/>
            { editFulfillmentView() }
            <br/>
            { transactionView() }
            <br/>
            <br/>
        </div>
    )
};

const subscriptionOption = [{
    name:`cekidot - monthly - Rp 9.900`,
    values: {
        name:'cekidot',
        type:'monthly',
        cycle:'1-month',
        price: 9900
    }
},{
    name:`cekidot - yearly - Rp 99.000`,
    values: {
        name:'cekidot',
        type:'yearly',
        cycle:'1-year',
        price: 99000
    }
},{
    name:`woo - essentials - monthly - Rp 49.000`,
    values: {
        name:'woocommerce',
        type:'essential',
        cycle:'1-month',
        price: 49000
    }
},{
    name:`woo - standard - monthly - Rp 79.000`,
    values: {
        name:'woocommerce',
        type:'standard',
        cycle:'1-month',
        price: 79000
    }
},{
    name:`woo - premium - monthly - Rp 99.000`,
    values: {
        name:'woocommerce',
        type:'premium',
        cycle:'1-month',
        price: 99000
    }
},{
    name:`woo - essentials - yearly - Rp 549.000`,
    values: {
        name:'woocommerce',
        type:'essential',
        cycle:'1-year',
        price: 549000
    }
},{
    name:`woo - standard - yearly - Rp 790.000`,
    values: {
        name:'woocommerce',
        type:'standard',
        cycle:'1-year',
        price: 790000
    }
},{
    name:`woo - premium - yearly - Rp 890.000`,
    values: {
        name:'woocommerce',
        type:'premium',
        cycle:'1-year',
        price: 890000
    }
},{
    name:`pricing api - max 1.000 / day - Rp 99.000`,
    values: {
        name:'pricingAPI',
        type:'essential',
        cycle:'1-month',
        price: 99000
    }
},{
    name:`pricing api - max 10.000 / day - Rp 490.000`,
    values: {
        name:'pricingAPI',
        type:'standard',
        cycle:'1-month',
        price: 490000
    }
},{
    name:`pricing api - max 100.000 / day - Rp 2.490.000`,
    values: {
        name:'pricingAPI',
        type:'premium',
        cycle:'1-month',
        price: 2490000
    }
}]



export default AdminUserPaymentInfo;
